export default (payload) => ({
  type: 'UPDATE_HISTORIES_STATE',
  payload,
});
